(function(angular){
	'use strict';
	
	angular.module('autoInvestFeatureModule', [
		'amountSelectModule',
		'coreModule',
		'futureEarningsChartModule',
		'optionsModule'
	]);

})(window.angular);